export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastPayload {
  type?: ToastType;
  message: string;
  duration?: number;
  onClick?: () => void;
}

export const TOAST_EVENT = 'app:toast';

export const showToast = (payload: ToastPayload | string, type: ToastType = 'info') => {
  const detail: ToastPayload = typeof payload === 'string'
    ? { message: payload, type }
    : { type: 'info', ...payload };

  window.dispatchEvent(new CustomEvent<ToastPayload>(TOAST_EVENT, { detail }));
};
